import { apiClient } from "@/lib/api-client";
import type { GetReminderChannelsResp } from "@/types/calendarEvent.ts";
import { queryOptions } from "@tanstack/react-query";

/** The reminder queries, for web and native alike. */
export const reminderQueries = {
  all: () => ["reminders"] as const,
  /**
   * The channels a reminder to the user can reach them on right now, ordered
   * text, WhatsApp, in app, email. Text is always listed; the server drops
   * WhatsApp until it's connected, and in app until a device takes push. Not every one of those changes from a screen that could invalidate
   * this (WhatsApp connects elsewhere, push registers on its own), so it is
   * always stale and every mount asks again.
   */
  channels: () =>
    queryOptions({
      queryKey: [...reminderQueries.all(), "channels"] as const,
      queryFn: async ({ signal }) => {
        const res = await apiClient.get<GetReminderChannelsResp>("/api/a/reminders/channels", {
          signal,
        });
        return res.data.channels;
      },
      staleTime: 0,
    }),
};
